import { Component, OnInit, ViewChild, QueryList, ViewChildren, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { DialogComponent, ButtonPropsModel } from '@syncfusion/ej2-angular-popups';

import { Repository } from '../../../services/repository'
import { ActivatedRoute } from '@angular/router';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';
import { ToolDataService} from '../../../services/tooldata.service'

import { cloneDeep } from "lodash";
import { HoSoCongChucs_chucnang12 } from '../../../routes/menu';
import 'jquery'
import 'bootstrap'
import { MaskedTextBoxComponent, FormValidators } from '@syncfusion/ej2-angular-inputs';

import { log } from 'util';
import { window } from 'ngx-bootstrap';

const swal = require('sweetalert');
@Component({
  selector: 'app-hscc-qtdt',
  templateUrl: './quatrinhdaotao.component.html',
  styleUrls: ['./quatrinhdaotao.component.scss'],
  providers: [ListService, Repository]
})


export class quatrinhdaotaoComponent implements OnInit {

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  public formatDate = '00/00/0000';
  public width: string = '50%';
  public animationSettings: AnimationSettingsModel = { effect: 'None' };
  public target: string = '.control-section';
  
  @ViewChild('Dialog') public modal: DialogComponent;

  @Output() save: EventEmitter<any> = new EventEmitter();

  @ViewChild('ejNgayQD') public ejNgayQD: MaskedTextBoxComponent;
  @ViewChild('ejNgayTN') public ejNgayTN: MaskedTextBoxComponent;
  @ViewChild('ejNgayDN') public ejNgayDN: MaskedTextBoxComponent;

  inputPhongBan2s: any = null;
  inputLinhVucs: any;
  inputChuyenNganhs: any ;
  inputHinhThucDaoTaos: any;
  inputTrinhDos: any;
  inputQuocGias: any;
  inputLoaiTotNghieps: any;
  inputkieungaysinhs: any = [{ Id: 1, Name: 'Đầy đủ' }, { Id: 2, Name: 'Thiếu ngày' }, { Id: 3, Name: 'Thiếu tháng' }]
  nhansuId: any = null;
  inputChucVus: any = null;
  inputHinhThucTuyenDungs: any = null;
  items = [];
  donviitems = [];

  //--------------------------------------------------------------------
  bonhiemSelect: any = {
    Id: null, NhanSuId: null, LinhVucDaoTaoId: null, HinhThucDaoTaoId: null, ChuyenNganhId: null, LoaiTotNghiepId: null, QuocGiaId: null,
    NoiDaoTaoId: null, DiaDiem: null, NoiDungDaoTao: null, SoQuyetDinh: null, NgayQuyetDinh: null, KieuNgayBatDau: null, NgayBatDau: null, KieuNgayKetThuc: null,
    NgayKetThuc: null, TrinhDoHocVanId: null, BangCapId: null, NamTotNghiep: null, MoTa: null, TrinhDoHocVan: null, ChuyenNganh: null, HinhThucDaoTao: null, LinhVucDaoTao: null
  }
  QTCT: any[];
  
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private route: ActivatedRoute, private repo: Repository, private tooldata: ToolDataService) {

   
  }

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  currentUser: any;
  ngOnInit(): void {
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      this.currentUser = JSON.parse(authlogin);

      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === HoSoCongChucs_chucnang12.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }
  }
  loadDataInit(id: string) {
    this.nhansuId = id;
    this.repo.getRequest("api/hoso/donvicaylist/", { phanloaiId: -1, giaithe: 1 })
      .subscribe(response => {
        this.donviitems = this.process(response);

      });
    this.repo.getRequest("api/hoso/chucvulist/", { entityName: "03" })
      .subscribe(response => {

        this.inputChucVus = response;
      });
    this.repo.getRequest("api/hoso/conmonlist/", { entityName: "DM_LinhVucDaoTao" })
      .subscribe(response => {
        this.inputLinhVucs = response;
      });
    this.repo.getRequest("api/hoso/conmonlist/", { entityName: "DM_ChuyenNganhDaoTao" })
      .subscribe(response => {
        this.inputChuyenNganhs = response;
      });
    this.repo.getRequest("api/hoso/conmonlist/", { entityName: "DM_HinhThucDaoTao" })
      .subscribe(response => {
        this.inputHinhThucDaoTaos = response;
      });
    this.repo.getRequest("api/hoso/bangcaplist/", { entityName:-1 })
      .subscribe(response => {
        this.inputTrinhDos = response;
      });
    this.repo.getRequest("api/hoso/conmonlist/", { entityName: "DM_LoaiTotNghiep" })
      .subscribe(response => {
        this.inputLoaiTotNghieps = response;
      });
    this.repo.getRequest("api/hoso/conmonlist/", { entityName: "DM_QuocGia" })
      .subscribe(response => {
        this.inputQuocGias = response;
      });
    this.loadGrid();
  }
  loadGrid() {
    this.repo.postRequest("api/hoso/getqtdt/", { id: this.nhansuId, status: 1 })
      .subscribe(response => {
        console.log(response);

        //var groups = new Set(response.map(item => item.LinhVucDaoTao))
        //console.log(response.map(item => item.LinhVucDaoTaoId));
        //this.QTCT = [];
        //groups.forEach(g =>
        //  this.QTCT.push({
        //    name: g,
        //    values: response.filter(i => i.LinhVucDaoTao === g)
        //  })
        //)

        this.QTCT = response;
      });
  }
  //-------------event
  hideBoNhiem: number = 1;
  public formatDatetn = '00/00/0000';
  public formatDatedn = '00/00/0000';
  boNhiemRowSelect(row) {
    //this.hideBoNhiem = 0;
    //this.QTCT.forEach(
    //  (r) => {
    //    r.DinhDang = 0;
    //  }
    //);
    //row.DinhDang = 1;
    this.bonhiemSelect = cloneDeep(row);
    if (this.bonhiemSelect.NgayBatDau != null)
      this.bonhiemSelect.NgayBatDau = new Date(this.bonhiemSelect.NgayBatDau);
    else
      this.bonhiemSelect.NgayThayDoi = null;
    if (this.bonhiemSelect.NgayKetThuc != null)
      this.bonhiemSelect.NgayKetThuc = new Date(this.bonhiemSelect.NgayKetThuc);
    else
      this.bonhiemSelect.NgayKetThuc = null;
    if (this.bonhiemSelect.NgayQuyetDinh != null)
      this.bonhiemSelect.NgayQuyetDinh = new Date(this.bonhiemSelect.NgayQuyetDinh);
    else
      this.bonhiemSelect.NgayQuyetDinh = null;
    this.onKieuTuNgayChange(null);
    this.onKieuDenNgayChange(null);
    this.onLinhVucChange(null);

    this.modal.show(true);
  }
  onKieuTuNgayChange($event) {
    if (this.bonhiemSelect.KieuNgayBatDau === 1) {
      this.formatDatetn = '00/00/0000';
    }
    if (this.bonhiemSelect.KieuNgayBatDau === 2) {
      this.formatDatetn = '00/0000';
    }
    if (this.bonhiemSelect.KieuNgayBatDau === 3) {
      this.formatDatetn = '0000';
    }
  }
  onKieuDenNgayChange($event) {
    if (this.bonhiemSelect.KieuNgayKetThuc === 1) {
      this.formatDatedn = '00/00/0000';
    }
    if (this.bonhiemSelect.KieuNgayKetThuc === 2) {
      this.formatDatedn = '00/0000';
    }
    if (this.bonhiemSelect.KieuNgayKetThuc === 3) {
      this.formatDatedn = '0000';
    }
   
  }
  onLinhVucChange($event) {
    console.log('vao day');
    this.repo.getRequest("api/hoso/bangcaplist/", { entityName: this.bonhiemSelect.LinhVucDaoTaoId })
      .subscribe(response => {
        this.inputTrinhDos = response;
      });
  }

  public dlgBtnClick = (): void => {
    this.modal.hide();
  }
  public dialogClose = (): void => {   
  }  
  public dialogOpen = (): void => {   
  }
  public dlgButtons: ButtonPropsModel[] = [
   { click: this.dlgBtnClick.bind(this), buttonModel: { content: 'Đóng', isPrimary: true } }
  ];
 
  RowNewDonViClick() {
   // this.hideBoNhiem = 0;
    this.bonhiemSelect = {
      Id: null, NhanSuId: null, LinhVucDaoTaoId: null, HinhThucDaoTaoId: null, ChuyenNganhId: null, LoaiTotNghiepId: null, QuocGiaId: null,
      NoiDaoTaoId: null, DiaDiem: null, NoiDungDaoTao: null, SoQuyetDinh: null, NgayQuyetDinh: null, KieuNgayBatDau: 2, NgayBatDau: null, KieuNgayKetThuc: 2,
      NgayKetThuc: null, TrinhDoHocVanId: null, BangCapId: null, NamTotNghiep: null, MoTa: null, TrinhDoHocVan: null, ChuyenNganh: null, HinhThucDaoTao: null, LinhVucDaoTao: null
    }
    //this.QTCT.forEach(
    //  (r) => {
    //    r.DinhDang = 0;
    //  }
    //);

       
    this.onKieuTuNgayChange(this.bonhiemSelect.KieuNgayBatDau);
    this.onKieuDenNgayChange(this.bonhiemSelect.KieuNgayKetThuc);

    this.modal.show();
  }
  public onNgayThayDoiChange(value: Date) {
    // Update the JSON birthDate string date
    //this.bonhiemSelect.NgayBatDau_S = this.intl.formatDate(value, 'dd/MM/yyyy');
  }
  public onNgayKetThucChange(value: Date) {
    // Update the JSON birthDate string date
   // this.bonhiemSelect.NgayKetThuc_S = this.intl.formatDate(value, 'dd/MM/yyyy');
  }
  public onNgayQuyetDinhChange(value: Date) {
    // Update the JSON birthDate string date
   // this.bonhiemSelect.NgayQuyetDinh_S = this.intl.formatDate(value, 'dd/MM/yyyy');
  }
  public savedt() {
    this.bonhiemSelect.NhanSuId = this.nhansuId;
    if (this.bonhiemSelect.NgayQuyetDinh_S != "")
      this.bonhiemSelect.NgayQuyetDinh_S = this.ejNgayQD.getMaskedValue();
    if (this.bonhiemSelect.NgayBatDau_S != "")
      this.bonhiemSelect.NgayBatDau_S = this.ejNgayTN.getMaskedValue();
    if (this.bonhiemSelect.NgayKetThuc_S != "")
      this.bonhiemSelect.NgayKetThuc_S = this.ejNgayDN.getMaskedValue();
    if (this.bonhiemSelect.LinhVucDaoTaoId === null || this.bonhiemSelect.LinhVucDaoTaoId === '') {
      swal('Cảnh báo!', "Bạn chưa nhập lĩnh vực đào tạo!!!", 'warning');
      return;
    }
    if (this.bonhiemSelect.ChuyenNganhId === null || this.bonhiemSelect.ChuyenNganhId === '') {
      swal('Cảnh báo!', "Bạn chưa nhập chuyên ngành đào tạo!!!", 'warning');
      return;
    }
    if (this.bonhiemSelect.HinhThucDaoTaoId === null || this.bonhiemSelect.HinhThucDaoTaoId === '') {
      swal('Cảnh báo!', "Bạn chưa nhập hình thức đào tạo!!!", 'warning');
      return;
    }

    this.modal.hide();
    this.repo.postRequest("api/hoso/addorupdate_qtdt", this.bonhiemSelect)
      .subscribe(response => {

        if (response.Status === "OK")
          this.loadGrid();
        else
          swal('Cảnh báo!', response.Status, 'warning');
      });
  }
  deleterow(index: number, id: string) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
        
          this.repo.getRequest('api/hoso/daotaodelete/' + id).subscribe(
            data => {
              if (data === "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');

                this.loadGrid();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
             
            }
          );
        }
      });


  }
  //---------------------------------------------
  private process(data): any {
    let result = [];
    result = data.map((item) => {
      return this.toTreeNode(item);
    });
    return result;
  }
  private toTreeNode(node, parent = null) {
    //console.log(node, parent);
    if (node && node.children) {
      node.children.map(item => {
        return this.toTreeNode(item, node);
      });
    }
    return node;
  }

}
